define('SageDotCom/DataLayer/Global/sticky-nav-tracker',[
    "jquery",
    "SageDotCom/DataLayer/Events/secondary-nav-interaction"
],
function ($, SecondaryNavInteractionEvent) {
    
    function StickyNavTracker() {
        this.scope = document.querySelector('.sticky-nav');
    }

    StickyNavTracker.prototype.start = function () {
        // Do not track if page doesn't have sticky navigation menu
        if (!this.scope) return;
        
        $(this.scope).on("click", "a[href]:not(.phone-number-component)", onLinkClick);
    }

    function onLinkClick(e) {
        new SecondaryNavInteractionEvent(e.currentTarget).trigger();
    }

    return StickyNavTracker;
});
